import axios from "axios";

// Create an instance using the config defaults provided by the library
// At this point the timeout config value is `0` as is the default for the library
const instance = axios.create();
// Override timeout default for the library
// Now all requests using this instance will wait 2.5 seconds before timing out
//instance.defaults.timeout = 2500;

// Alter defaults after instance has been created
const token = sessionStorage.getItem("token");
if (token) {
  instance.defaults.headers.common["Authorization"] = `bearer ${token}`;
} else {
  const curl = window.location.pathname;
  if (
    !curl.includes("/login") &&
    !curl.includes("/pa") &&
    !curl.includes("/privacy-policy") &&
    !curl.includes("/di-details") &&
    !curl.includes("/gazette-notification") &&
    !curl.includes("/carb-N6G") &&
    !curl.includes("/humacid") &&
     !curl.includes("/TAGLAMINARIA") &&
     !curl.includes("/TASBION") &&
    !curl.includes("/phantomgold") &&
    !curl.includes("/taglamina") &&
    !curl.includes("/tagzymegr") &&

     !curl.includes("/SUPERPOWERG") &&
      !curl.includes("/TAGBIO") &&
       !curl.includes("/TAGCALGR") &&
        !curl.includes("/TAGCAL") &&
         !curl.includes("/BIONOL100") &&

    !curl.includes("/tropicana")
  ) {
    window.location = "/login";
  }
}

instance.interceptors.response.use(
  (res) => {
    debugger;
    return res;
  },
  (err) => {
    const curl = window.location.pathname;
    if (
      err.response.status == 401 &&
      !curl.includes("/login") &&
      !curl.includes("/pa")
    ) {
      sessionStorage.removeItem("LoggedInUser");
      sessionStorage.removeItem("refreshToken");
      sessionStorage.removeItem("token");
      window.location = "/login";
    }
  }
);
// Override timeout for this request as it's known to take a long time
// instance.get('/longRequest', {
//     timeout: 5000
// });

export default instance;
